<template>
  <div class="booking-collect">
    <div class="booking-collect-top">
      <div class="booking-header">
        <div @click="$router.go(-1)">
          取消
        </div>
        <div
          class="booking-submit"
          @click="onConfirm"
        >
          完成
        </div>
      </div>
      <div class="booking-division" />
      <div class="booking-header-search">
        <form action="/">
          <van-search
            v-model="searchForm.value"
            placeholder="请输入搜索关键词"
            @search="onSearch"
            show-action
          >
            <template #action>
              <div @click="onSearch(searchForm.value)">搜索</div>
            </template>
          </van-search>
        </form>
      </div>
      <div class="booking-division" />
    </div>

    <div
      class="booking-collect-nomore"
      v-if="(productList.length === 0)"
    >
      暂无搜索结果
    </div>
    <div
      class="booking-collect-list"
      v-else
    >
      <div
        class="booking-collect-item"
        v-for="item in productList"
        :key="item.id"
        @click="onProductChange(item)"
      >
        <div class="booking-collect-item-box">
          <div class="booking-collect-item-check">
            <img
              v-show="!item.select"
              src="@/assets/images/booking/nor.png"
              alt=""
            />
            <img
              v-show="item.select"
              src="@/assets/images/booking/sel.png"
              alt=""
            />
          </div>
          <div class="booking-collect-item-content">
            <div>
              <span>
                {{ item.product_name }}
                <i
                  class="el-icon-warning-outline"
                  @click.stop="showDetail(item)"
                ></i>
              </span>
              <span>
                产品ID {{ item.id }}
              </span>
            </div>
            <div class="booking-collect-item-line"></div>
            <div>
              <span>
                价格自定义 {{ item.product_price }}
              </span>
              <span>
                {{ item.sell_count }}次
              </span>
            </div>
          </div>
        </div>
        <div class="booking-division" />
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogShow"
      :show-close="false"
      class="booking-collect-dialog"
      width="70%"
    >
      <div class="booking-collect-detail">
        <div class="booking-collect-detail-title">
          产品内容
        </div>
        <div class="booking-collect-detail-content">
          <div class="booking-collect-detail-item">
            产品名称：{{ detailInfo.product_name }}
          </div>
          <div class="booking-collect-detail-item">
            产品ID：{{ detailInfo.id }}
          </div>
          <div class="booking-collect-detail-item">
            产品价格：{{ detailInfo.product_price }}
          </div>
          <div class="booking-collect-detail-item">
            产品类型：{{ allEnum.ProductType && allEnum.ProductType[detailInfo.product_type] }}
          </div>
          <!-- <div class="booking-collect-detail-item">
            产品组成：{{ detailInfo.product_combi }}
          </div> -->
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";

export default {
  data() {
    return {
      productList: [],
      searchForm: {},
      currentProduct: undefined,
      dialogShow: false,
      detailInfo: {},
    };
  },
  mixins: [enums],

  created() {
    this.getProductList();
  },
  mounted() {},
  methods: {
    showDetail(item) {
      this.detailInfo = item;
      this.dialogShow = true;
    },
    onConfirm() {
      const { currentProduct } = this;
      if (!currentProduct) {
        Toast("请选择产品");
        return;
      }
      this.$store.dispatch("booking/setProductInfo", currentProduct);
      this.$router.go(-1);
    },
    onProductChange(option) {
      const { productList } = this;
      productList.forEach((item) => {
        item.select = false;
      });
      option.select = true;
      this.productList = [...productList];
      this.currentProduct = option;
    },
    getProductList(product_name = "") {
      const params = {
        order_type: "sell",
        product_name,
        product_type: 3,
        page_index: 1,
        page_size: 9999,
      };
      bookingService.productList(params).then((res) => {
        this.productList = res.data;
      });
    },
    onSearch(query) {
      this.getProductList(query);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-collect-nomore {
  color: rgba(4, 0, 0, 0.5);
  text-align: center;
  margin-top: 100px;
}
.booking-collect {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.booking-collect-top {
  flex-shrink: 0;
}
.booking-collect-search {
}
.booking-collect-list {
  flex: 1;
  overflow-y: scroll;
}
.booking-collect-item {
  .booking-collect-item-box {
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
  }
  .booking-collect-item-check {
    display: flex;
    align-items: center;
    img {
      height: 26px;
      width: 26px;
    }
  }
  .booking-collect-item-content {
    flex: 1;
    margin-left: 15px;
    & > div {
      display: flex;
      justify-content: space-between;
      span:nth-child(2) {
        flex-shrink: 0;
        margin-left: 10px;
      }
    }
  }
  .booking-collect-item-line {
    height: 1px;
    background-color: rgba(0, 48, 87, 0.1);
    margin-top: 13px;
    margin-bottom: 15px;
  }
}
.booking-collect-detail {
  color: #040000;
  .booking-collect-detail-title {
    font-size: 18px;

    font-weight: 500;
  }
  .booking-collect-detail-content {
    margin-top: 20px;
  }
  .booking-collect-detail-item {
    font-size: 15px;

    font-weight: normal;
  }
}
</style>
<style lang="scss">
</style>
